function S(s, scope = document) {
	return scope.querySelectorAll(s);
}

window.S = S;

// window.S = function(s) {
//     var c = {
//         '#': 'ById',
//         '.': 'sByClassName',
//         '@': 'sByName',
//         '=': 'sByTagName'}[s[0]];
//     return document[c?'getElement'+c:'querySelectorAll'](s.slice(1))
// };
